import { heapIdentify } from './heapIdentify';
import { heapTrack } from './heapTrack';

function heapUserEvent(guid, label, object) {
  heapIdentify(guid);
  heapTrack(label, object);
}

export { heapUserEvent };
